import { useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COLLETION_DOWNLOAD_EXCEL } from "./apiRoutes";
import { toast } from "sonner";

const downloadCollectionsExcel = async () => {
  const response = await axiosAuth.get(GET_COLLETION_DOWNLOAD_EXCEL, {
    responseType: "blob", // Important for binary data
  });

  if (response?.status === 200) {
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // ✅ Try extracting filename from headers
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "collections_report.xlsx";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) fileName = match[1];
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    toast.success("Collection Details downloaded successfully!");
    return fileName;
  } else {
    toast.error("There was an issue while downloading the Excel file.");
    throw new Error("Download failed");
  }
};

 const useDownloadCollectionsExcel = () => {
  return useMutation({
    mutationFn: downloadCollectionsExcel,
    onError: (error: any) => {
      const message =
        error?.response?.data?.data?.issues?.message ||
        error?.response?.data?.issues?.message ||
        "Failed to download Excel file.";
      toast.error(message);
    },
  });
};

export default useDownloadCollectionsExcel;